module.exports = __webpack_public_path__ + "img/title2-ja.d8c18986.png";